import request from '@/utils/request'

const service = (config) => {
  config.url = '/dsp' + config.url
  return request(config)
}

export default service
